<template>
  <div class="move-from-fixed-confirmation-popup">
    <popup :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:title>
        <span>
          המערכת לא תצפה {{ incomeOrExpense }} כ<span class="title" :class="originalCategory.cashflowCategory">"קבועה"</span> בעתיד מ-
        </span>
      </template>
      <template v-slot:content>
        {{ transaction.businessName }}
      </template>
      </popup>
    </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';
import Segment from '../../../../../../../../../../Segment';

import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ChangeTransactionCategoryPopup from './ChangeTransactionCategoryPopup.vue';
import MoveFromFixedSummaryPopup from './MoveFromFixedSummaryPopup.vue';

export default {
  name: 'MoveFromFixedConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('MoveFromFixedConfirmationPopup_Shown', { businessName: this.transaction.businessName });
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['selectedCategory', 'originalCategory', 'categoryToVariant', 'incomeOrExpense']),
    buttonOptions() {
      return [{
        title: 'הבנתי, אפשר להמשיך',
        action: this.onSave,
        variant: 'neutral',
      },
      {
        title: 'ביטול',
        action: this.back,
        variant: 'secondary-black',
      }];
    },
  },
  methods: {
    back() {
      Segment.trackUserInteraction('MoveFromFixedConfirmationPopup_BackClicked', {
        businessName: this.transaction.businessName,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    onSave() {
      Segment.trackUserInteraction('MoveFromFixedConfirmationPopup_AnswerClicked', {
        businessName: this.transaction.businessName,
      });
      ModalBus.$emit('open', {
        component: MoveFromFixedSummaryPopup,
        props: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';
  .title {
    @include category-color;
  }
</style>
